<mat-tab-group
  #tabGroup
  [selectedIndex]="layerListToolState.selectedTab$ | async"
  (selectedTabChange)="tabChanged($event)"
>
  <mat-tab [label]="'igo.integration.tools.layers' | translate">
    <igo-layer-viewer
      [options]="layerViewerOptions"
      [map]="map"
      [excludeBaseLayers]="excludeBaseLayers"
      [isDesktop]="isDesktop"
      (appliedFilterAndSort)="onLayerListChange($event)"
    >
      <ng-template #customBottomActions let-layer="layer">
        @if (isStyleEditButton(layer)) {
          <igo-style-modal-layer-button [layer]="layer" />
        }
        <igo-metadata-button [layer]="layer" />
        <igo-track-feature-button [trackFeature]="true" [layer]="layer" />
        @if (isTimeFilterButton(layer)) {
          <igo-time-filter-button
            [header]="timeButton()"
            [layer]="layer"
            (click)="activateTimeFilter()"
          />
        }
        @if (isOGCFilterButton(layer)) {
          <igo-ogc-filter-button
            [header]="ogcButton()"
            [layer]="layer"
            (click)="activateOgcFilter()"
          />
        }
        @if (isExportButton(layer)) {
          <igo-export-button [layer]="layer" (click)="activateExport(layer)" />
        }
        <igo-workspace-button [layer]="layer" />
      </ng-template>

      <ng-container ngProjectAs="[emptyList]">
        <ng-template [ngTemplateOutlet]="emptyLayers" />
      </ng-container>
    </igo-layer-viewer>
  </mat-tab>

  <mat-tab [label]="'igo.integration.tools.legend' | translate">
    @if (showAllLegend()) {
      <igo-layer-legend-list
        igoLayerLegendListBinding
        [allowShowAllLegends]="allowShowAllLegends()"
        [showAllLegendsValue]="showAllLegendsValue$ | async"
        (allLegendsShown)="onShowAllLegends($event)"
        [excludeBaseLayers]="excludeBaseLayers"
        [updateLegendOnResolutionChange]="updateLegendOnResolutionChange()"
      />
    }
    @if ((layers$ | async).length !== 0) {
    } @else {
      @if (delayedShowEmptyMapContent) {
        <mat-list>
          <p class="map-empty">
            {{ 'igo.integration.mapTool.empty' | translate }}
          </p>
          @if (
            layerAdditionAllowed() &&
            (searchToolInToolbar ||
              catalogToolInToolbar ||
              contextToolInToolbar)
          ) {
            <p class="map-empty">
              {{ 'igo.integration.mapTool.customize' | translate }}
            </p>
          }
          @if (layerAdditionAllowed() && searchToolInToolbar) {
            <mat-list-item>
              <mat-icon matListItemIcon>search</mat-icon>
              <span matListItemTitle class="search-tool" (click)="searchEmit()">
                {{ 'igo.integration.mapTool.search-tool' | translate }}
              </span>
            </mat-list-item>
          }
          @if (layerAdditionAllowed() && catalogToolInToolbar) {
            <mat-list-item>
              <mat-icon matListItemIcon>library_add</mat-icon>
              <span
                matListItemTitle
                class="catalog-tool"
                (click)="catalogEmit()"
              >
                {{ 'igo.integration.mapTool.catalog-tool' | translate }}
              </span>
            </mat-list-item>
          }
          @if (layerAdditionAllowed() && contextToolInToolbar) {
            <mat-list-item>
              <mat-icon matListItemIcon>star</mat-icon>
              <span
                matListItemTitle
                class="context-tool"
                (click)="contextEmit()"
              >
                {{ 'igo.integration.mapTool.context-tool' | translate }}
              </span>
            </mat-list-item>
          }
        </mat-list>
      }
    }

    @if (
      !allowShowAllLegends() &&
      (layers$ | async).length !== 0 &&
      (visibleOrInRangeLayers$ | async).length === 0
    ) {
      <p class="map-empty">
        {{
          (visibleLayers$ | async).length
            ? ('igo.integration.mapTool.noLayersInRange' | translate)
            : ('igo.integration.mapTool.noLayersVisible' | translate)
        }}
      </p>
    }
  </mat-tab>

  <ng-template #emptyLayers>
    @if (delayedShowEmptyMapContent) {
      <mat-list>
        <p class="map-empty">
          {{ 'igo.integration.mapTool.empty' | translate }}
        </p>
        @if (
          layerAdditionAllowed() &&
          (searchToolInToolbar || catalogToolInToolbar || contextToolInToolbar)
        ) {
          <p class="map-empty">
            {{ 'igo.integration.mapTool.customize' | translate }}
          </p>
        }
        @if (layerAdditionAllowed() && searchToolInToolbar) {
          <mat-list-item>
            <mat-icon matListItemIcon>search</mat-icon>
            <span matListItemTitle class="search-tool" (click)="searchEmit()">
              {{ 'igo.integration.mapTool.search-tool' | translate }}
            </span>
          </mat-list-item>
        }
        @if (layerAdditionAllowed() && catalogToolInToolbar) {
          <mat-list-item>
            <mat-icon matListItemIcon>library_add</mat-icon>
            <span matListItemTitle class="catalog-tool" (click)="catalogEmit()">
              {{ 'igo.integration.mapTool.catalog-tool' | translate }}
            </span>
          </mat-list-item>
        }
        @if (layerAdditionAllowed() && contextToolInToolbar) {
          <mat-list-item>
            <mat-icon matListItemIcon>star</mat-icon>
            <span matListItemTitle class="context-tool" (click)="contextEmit()">
              {{ 'igo.integration.mapTool.context-tool' | translate }}
            </span>
          </mat-list-item>
        }
      </mat-list>
    }
  </ng-template>
</mat-tab-group>
